import React from 'react'
import { Field } from 'redux-form'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Input, inputTypes } from 'components/common/FormElements/Input'
import Button from 'components/common/Button/Button'
import { normalizeNumber } from './helpers'

const CustomPriceRangeFormWrap = styled.form`
  margin-top: 17px;
`

const CustomInput = styled(Input)`
  margin-bottom: 15px;
  max-width: 100%;
`

const CustomPriceRangeForm = ({
  handleSubmit,
  submitting,
  vm: {
    minPrice,
    maxPrice,
    minPriceLabel,
    maxPriceLabel,
    priceInputType,
    required
  },
  valid,
  dirty
}) =>
  <CustomPriceRangeFormWrap onSubmit={ handleSubmit }>
    <Field
      type={ priceInputType }
      name={ minPrice }
      component={ CustomInput }
      inputType={ inputTypes.TEXT_INPUT }
      label={ minPriceLabel }
      required={ required }
      normalize={ normalizeNumber } />
    <Field
      type={ priceInputType }
      name={ maxPrice }
      component={ CustomInput }
      inputType={ inputTypes.TEXT_INPUT }
      label={ maxPriceLabel }
      required={ required }
      normalize={ normalizeNumber } />
    <Button data-at-custom-price-go disabled={ !dirty || !valid || submitting }>Go</Button>
  </CustomPriceRangeFormWrap>

export default CustomPriceRangeForm

CustomPriceRangeForm.propTypes = {
  dirty: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  vm: PropTypes.shape({
    minPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minPriceLabel: PropTypes.string,
    maxPriceLabel: PropTypes.string,
    priceInputType: PropTypes.string,
    required: PropTypes.bool
  })
}
